import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "image-preview"
}
const _hoisted_2 = { class: "text-end w-100" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "dialog-footer" }

import { ref, inject, computed } from "vue";
import ApiService from "@/core/services/Transaction.ts";
import { LoadingService } from "@/core/plugins/loading";
import { ElNotification } from "element-plus";
import SvgSprite from "@/components/shared/SvgSprite.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'UploadSlip',
  props: {
  modelValue: Boolean,
  selectedOrder: Object,
},
  setup(__props, { emit: __emit }) {

const $loading = inject("$loading") as LoadingService;

const props = __props;

const emit = __emit;

const isDialogVisibleUpload = computed({
  get: () => props.modelValue,
  set: (value) => {
    emit("update:modelValue", value);
  },
});

const previewUrl = ref("");
const fileList = ref<any[]>([]);

const handleDialogClose = () => {
  previewUrl.value = "";
  fileList.value = [];
  emit("update:modelValue", false);
};

const handlePaste = async (event: ClipboardEvent) => {
  const clipboardItems = event.clipboardData?.items;
  if (!clipboardItems) return;

  for (const item of clipboardItems) {
    if (item.type.startsWith("image")) {
      const file = item.getAsFile();
      if (file) {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          previewUrl.value = e.target.result;
          fileList.value = [file];
        };
        reader.readAsDataURL(file);
      }
    }
  }
};

document.addEventListener("paste", (event) => {
  handlePaste(event, fileList);
});

const uploadChange = (file: any) => {
  if (!file.raw) return;

  const reader = new FileReader();
  let isValidFile = true;

  if (!["image/jpeg", "image/png"].includes(file.raw.type)) {
    ElNotification({
      title: "Error",
      message: "The file must be JPG or PNG only!",
      type: "error",
    });
    isValidFile = false;
    return;
  }

  if (file.raw.size > 2 * 1024 * 1024) {
    ElNotification({
      title: "Error",
      message: "The file size must not exceed 2 MB!",
      type: "error",
    });
    isValidFile = false;
    return;
  }

  if (isValidFile) {
    reader.onload = (event) => {
      if (event.target?.result) {
        fileList.value = [file.raw];
        previewUrl.value = event.target.result as string;
      }
    };
    reader.readAsDataURL(file.raw);
  }
};

const handleDelete = () => {
  previewUrl.value = "";
  fileList.value = [];
};

const submitUpload = async () => {
  if (!fileList.value.length) {
    ElNotification({
      title: "Error",
      message: "Please select a file to upload.",
      type: "error",
    });
    return;
  }

  const file = fileList.value[0];
  const formData = new FormData();
  formData.append("slip", file);
  formData.append("order_id", props.selectedOrder.order_id);
  $loading.startLoading();

  const response = await ApiService.uploadSlip(formData);
  if (response.data.slip) {
    ElNotification({
      title: "Success",
      message: response.data.message,
      type: "success",
    });
    emit("submit-upload", response.data);
    handleDialogClose();
  } else {
    ElNotification({
      title: "Error",
      message: response?.error || "Unknown error",
      type: "error",
    });
  }
  $loading.endLoading();
};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: isDialogVisibleUpload.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isDialogVisibleUpload).value = $event)),
    title: "Upload Slip",
    width: "500",
    "align-center": "",
    "close-on-click-modal": false,
    onClose: handleDialogClose
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_button, {
          variant: "flat",
          type: "danger",
          onClick: handleDialogClose
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createTextVNode("Cancel")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: submitUpload
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [
            _createTextVNode("Upload")
          ])),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_upload, {
        "show-file-list": false,
        "on-change": uploadChange,
        "auto-upload": false,
        accept: "image/jpeg, image/png",
        drag: "",
        onPaste: handlePaste
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, {
            slot: "trigger",
            size: "small",
            type: "primary"
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode(" Select File ")
            ])),
            _: 1
          })
        ]),
        _: 1
      }),
      _cache[4] || (_cache[4] = _createElementVNode("div", {
        slot: "tip",
        class: "el-upload__tip"
      }, " The file size must not exceed 2 MB ", -1)),
      (previewUrl.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("button", { onClick: handleDelete }, [
                _createVNode(SvgSprite, {
                  name: "custom-trash",
                  style: {"width":"22px","height":"22px","color":"red"}
                })
              ])
            ]),
            _createElementVNode("img", {
              src: previewUrl.value,
              class: "w-100",
              alt: "Preview"
            }, null, 8, _hoisted_3)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})